import { createContext } from 'react';

interface ICopyableContext {
  isEmpty: boolean;
}

export const CopyableContext = createContext<ICopyableContext>({
  isEmpty: false,
});
